import { I18nManager } from "react-native";
function getLocaleDirection() {
  return I18nManager.getConstants().isRTL ? "rtl" : "ltr";
}
export {
  getLocaleDirection
};
//# sourceMappingURL=localeDirection.native.js.map
